import { styled } from 'styled-components';

import { media } from 'src/styles/breakpoints';

export const StyledHeader = styled.header`
  padding: 1.25rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-shrink: 0;
  background: ${({ theme }) => theme.background};
  border-bottom: 1px solid ${({ theme }) => theme.grey};
  z-index: 300;
  position: sticky;
  top: 0;

  ${media.md} {
    padding: 0.75rem 1rem;
    padding-top: max(0.75rem, env(safe-area-inset-top));
    padding-right: max(1rem, env(safe-area-inset-right));
    padding-left: max(1rem, env(safe-area-inset-left));
  }
`;

export const StyledHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  flex: 1;
`;

export const StyledRoleBadge = styled.span`
  color: ${({ theme }) => theme.primary};
  font-weight: 700;
  font-size: 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: 1rem;
  background: ${({ theme }) => theme.primary90};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 10rem;

  ${media.sm} {
    max-width: 6rem;
    font-size: 0.6875rem;
    padding: 0.35rem 0.5rem;
  }
`;

export const StyledIconsWrap = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-shrink: 0;
`;

export const StyledNavMenuButton = styled.button`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.grey};
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.background};
  cursor: pointer;
  color: ${({ theme }) => theme.dark};
  flex-shrink: 0;

  ${media.md} {
    display: flex;
  }

  &:hover {
    background: ${({ theme }) => theme.lightGrey};
  }

  svg {
    display: block;
  }
`;

export const StyledAccountMenuButton = styled.button`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.grey};
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.dark};
  flex-shrink: 0;

  &:hover {
    background: ${({ theme }) => theme.lightGrey};
  }

  svg {
    display: block;
  }
`;
